// OwnServiceFees.jsx
import React, { useState } from "react";

const AddServiceFee = ({ onClose }) => {
  const [feeName, setFeeName] = useState("");
  const [feeValue, setFeeValue] = useState("");
  const [defaultAdd, setDefaultAdd] = useState(true);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm p-6 rounded-xl shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-red-500 text-xl font-bold"
        >
          ×
        </button>
        <h3 className="text-lg font-semibold mb-4">Add Service Fee</h3>

        <label className="block mb-1">Fee Name</label>
        <input
          type="text"
          className="input mb-4 w-full px-3 py-2 border border-gray-300 rounded-md"
          value={feeName}
          onChange={(e) => setFeeName(e.target.value)}
        />

        <label className="block mb-1">Fee Value ($)</label>
        <input
          type="text"
          className="input mb-4 w-full px-3 py-2 border border-gray-300 rounded-md"
          value={feeValue}
          onChange={(e) => setFeeValue(e.target.value)}
        />

        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            id="defaultAddServiceFee"
            checked={defaultAdd}
            onChange={() => setDefaultAdd(!defaultAdd)}
            className="mr-2"
          />
          <label htmlFor="defaultAddServiceFee" className="text-sm text-gray-700">
            Default Add to Receipt
          </label>
        </div>

        <button className="w-full py-2 bg-primary text-white rounded-md">
          Save
        </button>
      </div>
    </div>
  );
};

const OwnServiceFees = () => {
  const [showAddModal, setShowAddModal] = useState(false);

  // Dummy data
  const serviceFees = [
    { name: "Consultation Fee", amount: "$10" },
    { name: "Support Fee", amount: "$5" },
    { name: "Installation Fee", amount: "$7" },
  ];

  return (
    <div className="relative min-h-screen bg-white rounded-xl shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Own Service Fees</h2>

      <div className="grid grid-cols-1 gap-4">
        {serviceFees.map((fee, index) => (
          <div
            key={index}
            className="bg-gray-50 p-4 rounded-lg shadow flex justify-between items-center"
          >
            <span className="text-gray-700 font-medium">{fee.name}</span>
            <span className="text-gray-600 font-semibold">{fee.amount}</span>
          </div>
        ))}
      </div>

      {/* Add New Button Fixed to Bottom */}
      <div className="absolute bottom-4 left-0 w-full px-4">
        <button
          onClick={() => setShowAddModal(true)}
          className="w-full bg-primary text-white py-2 rounded-md shadow-lg"
        >
          + Add New Service Fee
        </button>
      </div>

      {showAddModal && <AddServiceFee onClose={() => setShowAddModal(false)} />}
    </div>
  );
};

export default OwnServiceFees;
